import { Directive, ElementRef, HostBinding } from '@angular/core';

@Directive({
  selector: '[evkMatBody2]'
})
export class MatBody2Directive {

    @HostBinding('class')
    public class = 'mat-body-2';

}
